module.exports = __webpack_public_path__ + "static/img/logo.fc0d227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LNI/logo.png
// module id = BlKN
// module chunks = 0